import CrossIcon from "../../../shared/Icons/CrossIcon";
import { themeAtom } from "../../../shared/atoms";
import { RequestDocumentSelectionRowProps } from "../../models/document-request.models";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

const RequestDocumentSelectionRow: React.FC<RequestDocumentSelectionRowProps> = ({ document, disabled, onRemove }) => {
  const theme = useAtomValue(themeAtom);

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        aria-label={`Remove ${document.name}`}
        disabled={disabled}
        onClick={() => onRemove(document)}
        className="disabled:cursor-wait disabled:opacity-50"
      >
        <CrossIcon
          className={twMerge("hover:cursor-pointer hover:opacity-60", theme.myVesselsTable.tailwind.emptyStateText)}
        />
      </button>
      <p className="text-sm">{document.name}</p>
    </div>
  );
};

export default RequestDocumentSelectionRow;
